import { StatusBar, Style } from "@capacitor/status-bar";

export const setStatusBarStyleDark = async () => {
    await StatusBar.setStyle({ style: Style.Dark })
}

export const setStatusBarStyleLight = async () => {
    await StatusBar.setStyle({ style: Style.Light })
}